angular.module('ihestiaRestServicesBase')
  .factory('ihestiaRestVehicleDictionaryGearsTypesSvc', ['ihestiaRestAbstractVehicleDictionariesSvc',
    function(ihestiaRestAbstractVehicleDictionariesSvc) {

      var RestDictionaryVehicleSvc = function() {
        ihestiaRestAbstractVehicleDictionariesSvc.apply(this, arguments);

        this.id = 'gearsTypes';

      };
      return new RestDictionaryVehicleSvc();
    }
  ]);